// GuidingPrinciples.jsx
"use client";

import Image from "next/image";
import visionImg from "@/assets/whoweare/books-imagination-still-life 1.png";
import missionImg from "@/assets/whoweare/Mask group (5).png";
import philosophyImg from "@/assets/whoweare/problem-solving-concept-with-book 1.png";
import Intro from "@/ui/Intro";

const GuidingPrinciples = () => {
  return (
    <section className=" bg-[#fbf1dd]  py-3 ">
      <div className=" page-container pb-10">
        <Intro
          title="Our Guiding Principles"
          description="Anchoring our vision, mission and philosophy to a shared sense of purpose"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3  gap-6">
          {/* Vision */}
          <div
            className="group bg-white shadow-md flex flex-col transition-colors duration-300"
          >
            {/* flex-1 makes all description areas equal height */}
            <div className="flex-1 px-5 md:px-6 pt-5 md:pt-6 pb-4 md:pb-14 transition-colors duration-300 group-hover:bg-[#f9a825]">
              <h3
                style={{ fontFamily: "saans-bold" }}
                className="font-semibold text-lg md:text-[24px] mb-2 md:mb-3"
              >
                Our Vision
              </h3>
              <p
                style={{ fontFamily: "saans-regular" }}
                className="text-xs md:text-[18px] leading-relaxed text-[#333]"
              >
                To contribute to nation building by empowering the youths with
                skill‑integrated higher education linked to employability and
                entrepreneurship for a dignified career and life.
              </p>
            </div>

            <div className="mt-auto">
              <div className="border-t-4 border-[#0076a8] group-hover:border-[#f9a825]" />
              <Image
                src={visionImg}
                alt="Vision"
                className="w-full h-52 md:h-64 object-cover"
              />
            </div>
          </div>

          {/* Mission */}
          <div
            className="group bg-white shadow-md flex flex-col transition-colors duration-300"
          >
            <div className="flex-1 px-5 md:px-6 pt-5 md:pt-6 pb-4 md:pb-5 text-black transition-colors duration-300 group-hover:bg-[#f9a825]">
              <h3
                style={{ fontFamily: "saans-bold" }}
                className="font-semibold text-lg md:text-[24px] mb-2 md:mb-3"
              >
                Our Mission
              </h3>
              <div
                style={{ fontFamily: "saans-regular" }}
                className="text-xs md:text-[18px] leading-relaxed"
              >
                <ul className="list-disc pl-5 space-y-2 text-gray-700">
                  <li>
                    To promote skills in higher education in a holistic manner.
                  </li>
                  <li>
                    To stay relevant and future-ready in the changing landscape of technology, workforce, and skill gaps.
                  </li>
                  <li>
                    To promote career opportunities for socially and geographically marginalised/disadvantaged groups.
                  </li>
                </ul>

              </div>
            </div>

            <div className="mt-auto">
              <div className="border-t-4 border-[#0076a8] group-hover:border-[#f9a825]" />
              <Image
                src={missionImg}
                alt="Mission"
                className="w-full h-52 md:h-64 object-cover"
              />
            </div>
          </div>

          {/* Philosophy */}
          <div
            className="group bg-white shadow-md flex flex-col transition-colors duration-300"
          >
            <div className="flex-1 px-5 md:px-6 pt-5 md:pt-6 pb-4 md:pb-5 transition-colors duration-300 group-hover:bg-[#f9a825]">
              <h3
                style={{ fontFamily: "saans-bold" }}
                className="font-semibold text-lg md:text-[24px] mb-2 md:mb-3"
              >
                Our Philosophy
              </h3>
              <p
                style={{ fontFamily: "saans-regular" }}
                className="text-xs md:text-[18px] leading-relaxed text-[#333]"
              >
                Our philosophy of youth development through education lies in empowering the individual through Skills to explore the higher version of the self. Aligning passion and profession fosters creativity, dedication and purpose, leading to a fulfilling career.
              </p>
            </div>

            <div className="mt-auto">
              <div className="border-t-4  border-[#0076a8] group-hover:border-[#f9a825]" />
              <Image
                src={philosophyImg}
                alt="Philosophy"
                className="w-full h-52 md:h-64 object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuidingPrinciples;